<template>
    <DropdownButton
        class="xtype-dropdown"
        v-model="isOpen"
        :items="dropdownItems"
        :sections="dropdownSections"
        :show-checkbox="true"
        :ref-name="refName"
        button-icon="common__slider"
        @select="onSelect"
    >
        <template #button-badge>
            <SvgIcon name="X" style="position: absolute; top: 5px; right: 6px; width: 10px; height: 10px; z-index: 1;"/>
        </template>
    </DropdownButton>
</template>
<script>
import UnitsFilterDropdownButton from "@/components/units/dropdown/UnitsFilterDropdownButton";
import {mapGetters, mapMutations} from "vuex";

export default {
    name: 'UnitsFilterXTypesDropdownButton',
    extends: UnitsFilterDropdownButton,
    components: {
    },
    data() {
        return {
            open: false,
            refName: 'UnitsXTypes'
        }
    },
    computed: {
        ...mapGetters([
            "getUnitsXTypes",
            "showFilterXtypesDropdownMenu",
        ]),
        isOpen: {
            get() {
                return this.showFilterXtypesDropdownMenu
            },
            set(value) {
                this.setShowFilterXtypesDropdownMenu(value)
            },
        },
        unitsXTypes() {
            return this.getUnitsXTypes.map(xType => {
                return  {
                    label: this.$te('menu.products.'+xType.id) ? this.$t('menu.products.'+xType.id) : xType.title,
                    value: xType.id,
                    dataType: 'xtype',
                    icon: `xtype_`+xType.id,
                    iconClass: '',
                    isActive: this.routeQueryFilter.xtype === xType.id,
                }
            })
        },
        dropdownSections() {
            return [
                {
                    key: 'all',
                    items: [
                        {
                            label: this.$t('menu.products.all'),
                            value: '__reset__',
                            dataType: 'reset',
                            icon: 'common__car',
                            iconClass: '',
                            isActive: this.isAllFiltersEmpty,
                        },
                    ],
                },
                {
                    key: 'xtype',
                    items: this.unitsXTypes,
                },
            ]
        },

        isAllFiltersEmpty() {
            return !this.routeQueryFilter?.xtype
        },
    },
    methods: {
        ...mapMutations([
            "setShowFilterXtypesDropdownMenu"
        ])
    }
}
</script>

<style scoped lang="scss">
::v-deep(.button) {
    &.button_view_icon {
        background: var(--Elements-BG);
        border: 1px solid var(--Stroke-in-Light-Mode, #AED0F3);
        border-radius: 8px;
        height: 2.25rem;
        min-height: 2.25rem;
    }
    &.dropdown-button--button-open {
        background: var(--XSuite-Gradient);
        .svg-icon {
            color: white !important;
        }
    }

}
</style>